import React from "react";
import {
  Box,
  Container,
  Card,
  CardContent,
  useTheme
} from "@mui/material";
import MKBox from "../components/MKBox";
import MKTypography from "../components/MKTypography";
import { ShoppingBag } from "@mui/icons-material";

function MerchPage() {
  const theme = useTheme();

  return (
    <Box sx={{ minHeight: "100vh", py: 8 }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <MKTypography
            variant="h2"
            fontWeight="bold"
            mb={3}
            sx={{
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              lineHeight: 1.2,
              color: '#e91e63'
            }}
          >
            SD Gaming Merch
          </MKTypography>
          <MKTypography
            variant="h5"
            sx={{ 
              maxWidth: 600, 
              mx: 'auto',
              color: theme.palette.mode === 'dark' ? 'white !important' : '#333333 !important'
            }}
          >
            Official merchandise coming soon!
          </MKTypography>
        </Box>

        <Card
          sx={{
            maxWidth: 600,
            mx: 'auto',
            textAlign: 'center',
            p: 6,
            background: theme.palette.mode === 'dark' 
              ? 'linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%)'
              : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white'
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 120,
                height: 120,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)',
                mb: 4
              }}
            >
              <ShoppingBag sx={{ fontSize: 60, color: 'white !important' }} />
            </Box>
            
            <MKTypography
              variant="h3"
              fontWeight="bold"
              mb={3}
              sx={{ color: 'white !important' }}
            >
              Coming Soon
            </MKTypography>
            
            <MKTypography
              variant="h6"
              mb={4}
              sx={{ 
                color: 'rgba(255,255,255,0.9)',
                lineHeight: 1.6
              }}
            >
              We're working hard to bring you the best SD Gaming merchandise. 
              Stay tuned for official t-shirts, hoodies, and more!
            </MKTypography>
            
            <MKTypography
              variant="body1"
              sx={{ 
                color: 'rgba(255,255,255,0.8)',
                fontStyle: 'italic'
              }}
            >
              Follow us on social media for updates and early access to our merch drops.
            </MKTypography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}

export default MerchPage; 